import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { tags } from '../consts/Tags.js';
import { IntroData } from '../consts/Data.js';

export default class Intro extends AbstractScene {
    constructor() {
        super({
            key: "Intro"
        })
    }
    init(data) {
        this._init(data);
    }


    preload() {
        this._preload();
        this.introData = IntroData;
        this.elements = []
    }



    create() {
        this.clickSound = this.sound.add('click', { volume: 0.4 });
        this.mainLogo = this.add.image(this.width / 2, 500, 'mainLogo').setOrigin(0.5);
        this.startBtn = new ButtonImageSliced(this, 960, 910, 320, 80, "bouton", "Démarrer")
        this.startBtn.setClickFunction(() => {
            this.showIntroPhase2()
        })

        this.creditsBtn = this.add.text(100, 1040, "Crédits", {
            fontFamily: 'CenturyGothic',
            fontSize: '36px',
            color: Colors.Text.Black
        }).setOrigin(0.5);
        this.creditsBtn.setInteractive({ useHandCursor: true });
        this.creditsBtn.on('pointerdown', () => {
            this.clickSound.play();
            this.showPopupCredits();
        });

    }

    showPopupCredits() {
        console.log('showPopupCredits');
        this.startBtn.setLocked()
        this.creditsBtn.disableInteractive()
        this.creditsContainer = this.add.container(0, 1020);
        let popupBg = this.add.rexRoundRectangle(this.width / 2, this.height / 2, 1610, 860, 20, Colors.Elmt.MainBlue).setAlpha(1);
        this.creditsContainer.add(popupBg);

        let closeBtn = this.add.text(this.width / 2 + 750, this.height / 2 - 400, "X", {
            fontFamily: 'CenturyGothicBold',
            fontSize: '48px',
            color: Colors.Text.White
        }).setOrigin(0.5);
        closeBtn.setInteractive({ useHandCursor: true });
        closeBtn.on('pointerdown', () => {
            this.tweens.add({
                targets: this.creditsContainer,
                y: 1020,
                duration: 200,
                onComplete: () => {
                    this.startBtn.setUnlocked()
                    this.creditsContainer.destroy();
                    this.creditsBtn.setInteractive({ useHandCursor: true });

                }
            })
        });
        this.creditsContainer.add(closeBtn);

        this.line1 = this.createTextElement(210, 155, this.introData.line1);
        this.line2 = this.createTextElement(210, 400, this.introData.line2);
        this.line3 = this.createTextElement(this.width / 2, 855, this.introData.line3);
        this.creditsContainer.add(this.line1);
        this.creditsContainer.add(this.line2);
        this.creditsContainer.add(this.line3);

        for (let i = 0; i < this.introData.items.length; i++) {
            const el = this.introData.items[i];
            let itemText = this.createTextElement(702, 180 + el.suppY, el.content);
            this.creditsContainer.add(itemText);
            let itemLogo = this.add.image(655, el.logoY, el.logo).setOrigin(1, 0.5)
            this.creditsContainer.add(itemLogo);
            this.creditsContainer.add(itemText);
        }

        this.tweens.add({
            targets: this.creditsContainer,
            y: 0,
            duration: 200,
        })


    }

    showIntroPhase2() {
        this.mainLogo.destroy()
        this.startBtn.destroy()
        this.creditsBtn.destroy()
        this.elements = []


        this.bigTitle = this.createTextElement(this.width / 2, 190, this.introData.bigTitle).setAlpha(0)
        this.elements.push(this.bigTitle)
        this.volumeLogo = this.add.image(this.width / 2, 500, 'volume').setOrigin(0.5).setAlpha(0)
        this.elements.push(this.volumeLogo)
        this.soundText = this.createTextElement(this.width / 2, 630, this.introData.soundText).setAlpha(0)
        this.elements.push(this.soundText)


        this.nextBtn = new ButtonImageSliced(this, 960, 910, 320, 80, "bouton", "Suivant").setAlpha(0)
        this.elements.push(this.nextBtn)
        this.nextBtn.setClickFunction(() => {
            this.scene.start('VideoIntro')
        })

        this.elements.forEach((el, id) => {
            this.tweens.add({
                targets: el,
                alpha: 1,
                duration: 300,
                ease: 'Power2',
                delay: id * 300,
            })
        })

    }
}